import { useContext } from 'react'
import { UserPreferencesContext } from './context/user-preferences/user-preferences-context'
import {
  formatDistance,
  formatArea,
  formatMass,
  toDisplayMass,
  fromDisplayMass,
} from './measurement-utils'

export const useMeasurementUnits = () => {
  const { userPreferences } = useContext(UserPreferencesContext)
  const distanceUnit = userPreferences?.distance_unit || 'm'
  const areaUnit = userPreferences?.area_unit || 'm²'
  const massUnit = userPreferences?.mass_unit || 'kg'

  return {
    distanceUnit,
    areaUnit,
    massUnit,
    formatDistance: (meters) => formatDistance(meters, distanceUnit),
    formatArea: (m2) => formatArea(m2, areaUnit),
    formatMass: (kg) => formatMass(kg, massUnit),
    toDisplayMass: (kg) => toDisplayMass(kg, massUnit),
    fromDisplayMass: (val) => fromDisplayMass(val, massUnit),
  }
}
